/**
 * Because this is the web implementation of the passkey service, we need to
 * import the browser's WebAuthn API directly.
 */
import {
  // eslint-disable-next-line no-restricted-syntax
  browserSupportsWebAuthn,
  // eslint-disable-next-line no-restricted-syntax
  startAuthentication,
  // eslint-disable-next-line no-restricted-syntax
  startRegistration,
} from '@simplewebauthn/browser';

import type { PasskeyService } from '../passkey.types';

/**
 * Create a passkey service that uses the browser's WebAuthn API.
 */
export const createWebPasskeyService = (): PasskeyService => ({
  authenticate: (options) => startAuthentication(options),
  isSupported: () => browserSupportsWebAuthn(),
  register: (options) => startRegistration(options),
});
